"use client"

import Text from "@/components/common/Typography/Text"
import Title from "@/components/common/Typography/Title"
import { Col, Row } from "antd"
import TourCategorySort from "./TourCategorySort"
import TourCategoryRouteChips from "./TourCategoryRouteChips"
import { useMemo } from "react"
import { useParams } from "next/navigation"
import { useToursCategories } from "@/hooks/tour/useToursCategories"
import { useAppSelector } from "@/lib/redux/hooks"
import { useTranslation } from "react-i18next"
import { extractTourRouteLabel } from "./TourCategoryRouteChips"

const TopContent = () => {
  const params = useParams()
  const { data: { tourCategories } } = useToursCategories()
  const tours = useAppSelector((state) => state.tour.tours_search.data)
  const totalTours = useAppSelector((state) => state.tour.tours_search.filter?.total || 0)
  const priceRange = useAppSelector((state) => state.tour.formSearch.priceRange)
  const durationDays = useAppSelector((state) => state.tour.formSearch.durationDays)
  const routeFilter = useAppSelector((state) => state.tour.formSearch.routeFilter)
  const { t } = useTranslation()

  const selectedCategory = useMemo(() => {
    if (params?.categoryId && !!tourCategories?.length) {
      return tourCategories?.find((tourCategory) => tourCategory.id === params?.categoryId)
    }
    return null
  }, [params?.categoryId, tourCategories?.length])

  const filteredCount = useMemo(() => {
    let result = tours
    if (priceRange) {
      result = result.filter((tour) => {
        const price = parseFloat(tour.priceDefault)
        return price >= priceRange[0] && price <= priceRange[1]
      })
    }
    if (durationDays) {
      const [min, max] = durationDays
      result = result.filter((tour) => tour.totalDay >= min && tour.totalDay <= max)
    }
    if (routeFilter) {
      result = result.filter(
        (tour) => extractTourRouteLabel(tour.tourName) === routeFilter
      )
    }
    return result.length
  }, [tours, priceRange, durationDays, routeFilter])

  const tourCount = filteredCount || totalTours

  return (
    <div className="tour-category__header">
      <Row align="middle" justify="space-between" wrap={false} className="tour-category__heading-row">
        <Col flex="auto" className="tour-category__heading-title-col">
          <Title level={2} className="tour-category__title">
            {selectedCategory?.name ?? ""}
          </Title>
        </Col>
        <Col flex="none">
          <Text className="tour-category__count">
            {t("tour.matching_tours", { count: tourCount })}
          </Text>
        </Col>
      </Row>
      <Row
        align="middle"
        justify="space-between"
        wrap={false}
        className="tour-category__toolbar-routes"
      >
        <Col flex="auto" className="tour-category__toolbar-routes-col">
          <TourCategoryRouteChips />
        </Col>
        <Col flex="none" className="tour-category__toolbar-sort">
          <TourCategorySort />
        </Col>
      </Row>
    </div>
  )
}

export default TopContent
